import { EventType, IEvent } from 'types'
import { isValid, parseISO } from 'date-fns'

const nowIso = new Date().toISOString()

const breastFields = {
  startTime: nowIso,
  endTime: nowIso,
  comment: '',
}

const bottleFields = {
  comment: '',
  volume: 0,
  startTime: nowIso,
  endTime: nowIso,
}

const sleepFields = {
  type: '',
  startTime: nowIso,
  endTime: nowIso,
  comment: '',
}

const poopFields = {
  startTime: nowIso,
  comment: '',
}

const peeFields = {
  startTime: nowIso,
  volume: 0,
  comment: '',
}

const eventsMap: Record<string, Omit<IEvent, 'eventTypeCode'>> = {
  [EventType.BREAST_LEFT]: breastFields,
  [EventType.BREAST_RIGHT]: breastFields,
  [EventType.BOTTLE]: bottleFields,
  [EventType.SLEEP_DAY]: sleepFields,
  [EventType.SLEEP_NIGHT]: sleepFields,
  [EventType.POO]: poopFields,
  [EventType.PEE]: peeFields,
}

export const createEvent = (type?: string) => {
  if (!type || !eventsMap[type]) return null

  const now = new Date().toISOString()
  const event = { ...eventsMap[type] }

  if ('startTime' in event) {
    event.startTime = now
  }

  if ('endTime' in event) {
    event.endTime = now
  }

  return event
}

const normalizeDate = (date: string) => {
  const parsedDate = parseISO(date)

  if (!isValid(parsedDate)) return date

  parsedDate.setMilliseconds(0)

  return parsedDate.toISOString()
}

export const serializeEvent = (event: IEvent, type: EventType) => {
  const processedEvent = {
    ...event,
    eventTypeCode: type,
  }

  if (event.startTime) {
    processedEvent.startTime = normalizeDate(event.startTime)
  }

  if (event.endTime) {
    processedEvent.endTime = normalizeDate(event.endTime)
  }

  return processedEvent
}
